import React from 'react';
import NlQSearchBox from 'share/components/controls/NLQSuggestionBox/Izenda.NlQSearchBox';
import NLQSuggestionList from 'share/components/controls/NLQSuggestionBox/Izenda.NLQSuggestionList';

function NLQSuggestionBox(props) {
  const {
    showResult,
    placeholder,
    shouldFocus,
    disabled,
    value, 
    onKeyPress,
    onChange,
    isActive,
    suggestionList,
    onSearch,
    onSelectedSuggestion,
    isOverlayOpen,
    disabledWrapper
  } = props;
  const wrapperClassName = suggestionList &&  suggestionList.length ? 'overlay-suggestion-list active' : 'overlay-suggestion-list';
  return (
    !showResult &&
    <div className='search-wrapper suggestion-list-shadow'>
      <NlQSearchBox
        placeholder={placeholder}
        showResult={showResult}
        shouldFocus={shouldFocus}
        disabled={disabled}
        value={value}
        onKeyPress={onKeyPress}
        onChange={onChange}
        isActive={isActive}
        onSearch={onSearch}
      >
        {suggestionList &&  suggestionList.length > 0 && (
          <NLQSuggestionList
            suggestionList={suggestionList}
            showResult={showResult}
            onSelectedSuggestion={onSelectedSuggestion}
          />
        )}
      </NlQSearchBox>
      <div className={wrapperClassName} onClick={disabledWrapper}></div>
    </div>
  );
}

export default NLQSuggestionBox;



// WEBPACK FOOTER //
// ./ui/share/components/controls/NLQSuggestionBox/Izenda.NLQSuggestionBox.js